export default "__VITE_PUBLIC_ASSET__648a0c51__"